export default "__VITE_ASSET__DC0MjgLj__"